import levelUpEvents from './events/levelUp';
import { pursuitEvent, randomEvent } from './events/randomEvents';
import { passiveCrime } from './actions';

const rob = {
  label: 'Crime',
  levels: [
    {
      name: 'Amateur',
      minExperience: 0,
      actionLabel: 'Rob',
      description: 'learning the ropes of the criminal world',
      bonus: 0.0,
      randomEvents: [],
      dailyBenefits: []
    },
    {
      name: 'Pickpocket',
      minExperience: 10,
      actionLabel: 'Rob',
      description: 'mastering the art of stealth and quick hands',
      bonus: 0.05,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Pickpocket')),
      randomEvents: [],
      dailyBenefits: []
    },
    {
      name: 'Mugger',
      minExperience: 25,
      actionLabel: 'Rob',
      description: "using force to take what's not given freely",
      bonus: 0.1,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Mugger')),
      randomEvents: [],
      dailyBenefits: []
    },
    {
      name: 'Confidence Trickster',
      minExperience: 45,
      actionLabel: 'Ruse',
      description: 'manipulating marks with charm and deceit',
      bonus: 0.15,
      onLevelUp: (context, setEvent) =>
        levelUpEvents(context, setEvent).find(p => p.title.includes('Confidence Trickster')),
      randomEvents: [],
      dailyBenefits: []
    },
    {
      name: 'Fence',
      minExperience: 70,
      actionLabel: 'Resell',
      description: 'dealing in stolen goods, no questions asked',
      bonus: 0.2,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Fence')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.1)]
    },
    {
      name: 'Rustler',
      minExperience: 100,
      actionLabel: 'Rustle',
      description: 'stealing livestock as silently as a shadow',
      bonus: 0.25,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Rustler')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.2)]
    },
    {
      name: 'Muscle',
      minExperience: 135,
      actionLabel: 'Rough Up',
      description: 'ensuring debts are paid and respect is given',
      bonus: 0.3,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Muscle')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.3)]
    },
    {
      name: 'Highwayman',
      minExperience: 175,
      actionLabel: 'Raid',
      description: 'commanding the roads, robbing carriages with flair',
      bonus: 0.4,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Highwayman')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.4)]
    },
    {
      name: 'Stagecoach Robber',
      minExperience: 220,
      actionLabel: 'Raid',
      description: 'daring raids on the wealthiest travelers',
      bonus: 0.5,
      onLevelUp: (context, setEvent) =>
        levelUpEvents(context, setEvent).find(p => p.title.includes('Stagecoach Robber')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.5)]
    },
    {
      name: 'Lieutenant',
      minExperience: 270,
      actionLabel: 'Raid',
      description: 'leading a band of outlaws with cunning and strength',
      bonus: 0.6,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Lieutenant')),
      randomEvents: [],
      dailyBenefits: [passiveCrime(0.6)]
    },
    {
      name: 'Outlaw Legend',
      minExperience: 350,
      actionLabel: 'Raid',
      description: 'a feared leader, a legend whispered across the lands',
      bonus: 0.75,
      onLevelUp: (context, setEvent) => levelUpEvents(context, setEvent).find(p => p.title.includes('Outlaw Legend')),
      randomEvents: [],
      gailyBenefits: [passiveCrime(0.75)]
    }
  ],
  randomEvent,
  pursuitEvent,
  traitMultipliers: {
    infamy: 0.05
    // Intimidation: 0.04,
  }
};

export default rob;
